import styled from 'styled-components';
import { mediaQuery } from '@design-system/Breakpoints/Breakpoints';

export const LinkBox = styled.div`
  padding-left: 15px;
  padding-top: 15px;
  background: #fafafa;

  ${mediaQuery.desktop`
  padding-left: 64px;
  padding-top: 15px;
  background: #fafafa;
  `}
`;

export const Container = styled.div`
  display: flex;
  gap: 15px;
  padding: 11px 15px;
  background: #fafafa;
  flex-direction: column;

  .shipping {
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 100%;
  }

  .summary {
    width: 100%;
  }

  .method {
    background: #fff;
    border-radius: 4px;
    border: 1px solid #e0e0e0;
  }

  .address {
    background: #fff;
    border-radius: 4px;
    border: 1px solid #e0e0e0;
  }

  .header {
    padding: 15px;
    color: #333333;
    font-weight: 700;
    text-transform: capitalize;
    font-size: 16px;
    border-bottom: 1px solid #e0e0e0;
  }

  .body {
    padding: 15px;
    display: flex;
    flex-direction: column;
    gap: 13px;
  }

  .tabs {
    display: flex;
    gap: 8px;
    align-items: flex-start;
    justify-content: baseline;
    cursor: pointer;

    .tab-selected {
      border: 1px solid #549a9a;
      border-radius: 100%;
      background: #d4e7e7;
      width: 16px;
      height: 16px;
      display: flex;
      justify-content: center;
      align-content: center;
      align-items: center;

      .inner {
        background: #549a9a;
        width: 6px;
        height: 6px;
        border-radius: 100%;
      }
    }

    h4 {
      margin: 0;
      color: #333333;
      font-size: 14px;
      font-weight: 700;
      text-transform: capitalize;
    }

    h5 {
      margin: 0;
      color: #4f4f4f;
      font-weight: 400;
      font-size: 12px;
    }
  }

  ${mediaQuery.desktop`
  display: flex;
  gap: 15px;
  padding: 24px 64px;
  background: #fafafa;
  flex-direction: row;
  align-items: stretch;


  .shipping {
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 850px;
  }

  .summary {
    width: 429px;
  }

  .method {
    background: #fff;
    border-radius:4px;
    border: 1px solid #E0E0E0;
  }

  .address {
    background: #fff;
    border-radius:4px;
    border: 1px solid #E0E0E0;
  }

  .header {
    padding: 15px;
    color: #333333;
    font-weight: 700;
    text-transform: capitalize;
    font-size: 18px;
    border-bottom: 1px solid #e0e0e0;
  }

  .body {
    padding: 15px;
    display: flex;
    flex-direction: row;
    gap: 200px;
  }

  .tabs {
    display: flex;
    gap: 8px;
    align-items: flex-start;
    justify-content: baseline;
    cursor: pointer;

    .tab-selected {
      border: 1px solid #549A9A;
      border-radius: 100%;
      background: #D4E7E7;
      width: 16px;
      height: 16px;
      display: flex;
      justify-content: center;
      align-content: center;
      align-items: center;

      .inner {
        background: #549A9A;
        width: 6px;
        height: 6px;
        border-radius: 100%;
      }
    }

    h4 {
      margin: 0;
      color: #333333;
      font-size: 14px;
      font-weight: 700;
      text-transform: capitalize;
    }

    h5 {
      margin: 0;
      color: #4F4F4F;
      font-weight: 400;
      font-size: 12px;
    }
  }
  
  `}
`;

export const CartSummary = styled.div`
  background: #fff;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  width: auto;

  .header {
    padding: 15px;
    color: #333333;
    font-weight: 700;
    text-transform: capitalize;
    font-size: 18px;
    border-bottom: 1px solid #e0e0e0;
  }

  .body {
    padding: 15px;
    display: flex;
    flex-direction: column;
  }

  .products {
    display: flex;
    gap: 30px;
    flex-direction: column;

    .card {
      display: flex;
      gap: 8px;
      margin-bottom: 20px;

      .image {
        width: 66px;
        height: auto;
        border-radius: 2px;
        background: #e0e0e0;
        object-fit: cover;
      }

      .delete {
        display: flex;
        justify-content: flex-end;
        cursor: pointer;
      }

      .content {
        display: flex;
        flex-direction: column;
        gap: 8px;
        width: 100%;

        h3 {
          margin: 0;
          color: #333333;
          font-size: 14px;
          font-weight: 400;
        }

        h4 {
          margin: 0;
          color: #333333;
          font-weight: 500;
          font-size: 14px;
        }

        h5 {
          color: #4f4f4f;
          font-size: 14px;
          font-weight: 500;
          margin: 0;
        }
      }
    }
  }

  .summary_total {
    border-top: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
  }

  .sub_total {
    padding-top: 18px;
    padding-bottom: 18px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    h4 {
      margin: 0;
      color: #333333;
      font-weight: 400;
      font-size: 16px;
    }

    h5 {
      margin: 0;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
    }
  }

  .total {
    padding-top: 18px;
    padding-bottom: 18px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    h4 {
      margin: 0;
      color: #333333;
      font-weight: 700;
      font-size: 16px;
    }

    h5 {
      margin: 0;
      font-weight: 700;
      font-size: 16px;
      color: #549a9a;
    }
  }

  .coupon {
    display: flex;
    gap: 10px;
    margin-bttom: 30px;
    flex-direction: column;
    input {
      background: none;
      border: 1px solid #e0e0e0;
      font-size: 16px;
      padding: 1rem 2rem;
      padding-left: 10px;

      ::placeholder {
        color: #c4c4c4;
      }

      &:focus {
        outline: none;
        border: 2px solid #549a9a;
      }
    }
  }

  ${mediaQuery.desktop` 
  background: #fff;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  width: auto;

  .header {
    padding: 15px;
    color: #333333;
    font-weight: 700;
    text-transform: capitalize;
    font-size: 18px;
    border-bottom: 1px solid #e0e0e0;
  }

  .body {
    padding: 15px;
    display: block;
    flex-direction: column;
    width: 100%;
    box-sizing: border-box;
  }

  .products {
    display: flex;
    gap: 24px;
    flex-direction: column;

    .card {
      display: flex;
      gap: 8px;
      padding-bottom: 10px;

      .image {
        width: 66px;
        height: 86px;
        border-radius: 2px;
        background: #e0e0e0;
      }

      .content {
        display: flex;
        flex-direction: column;
        gap: 8px;

        h3 {
          margin: 0;
          color: #333333;
          font-size: 14px;
          font-weight: 400;
        }

        h4 {
          margin: 0;
          color: #333333;
          font-weight: 500;
          font-size: 14px;
        }

        h5 {
          color: #4F4F4F;
          font-size: 14px;
          font-weight: 500;
          margin: 0;
        }
      }
    }
  }

  .summary_total {
    border-top: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
  }

  .sub_total {
    padding-top: 18px;
    padding-bottom: 18px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    h4 {
      margin: 0;
      color: #333333;
      font-weight: 400;
      font-size: 16px;
    }

    h5 {
      margin: 0;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
    }
  }


  .total {
    padding-top: 18px;
    padding-bottom: 18px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    h4 {
      margin: 0;
      color: #333333;
      font-weight: 700;
      font-size: 16px;
    }

    h5 {
      margin: 0;
      font-weight: 700;
      font-size: 16px;
      color: #549a9a;
    }
  }
  
  .coupon {
    display: flex;
    flex-direction: row;
    gap: 24px;
    align-items: center;

    input {
      background: none;
      border: 1px solid #e0e0e0;
      font-size: 16px;
      padding: 0;
      padding-left: 10px;
      height:50px;
      border-radius: 5px;

      ::placeholder {
        color: #c4c4c4;
      }

      &:focus {
        outline: none;
        border: 2px solid #549a9a;
      }
    }
  }
  
  `}
`;

export const PickupContainer = styled.div`
  background: #fff;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  width: auto;

  .header {
    padding: 15px;
    color: #333333;
    font-weight: 700;
    text-transform: capitalize;
    font-size: 14px;
    border-bottom: 1px solid #e0e0e0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h4 {
      margin: 0;
      color: #549a9a;
      font-size: 12px;
      font-weight: 700;
      cursor: pointer;
    }
  }

  .pickup_note {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 15px;
    padding: 15px;

    .card {
      padding: 14px;
      cursor: pointer;
      border-radius: 5px;
      width: auto;
      border: 1px solid #e0e0e0;

      p {
        margin: 0;
        color: #0b0b0b;
        margin-bottom: 6px;
        font-size: 16px;
        font-weight: 500;
      }

      h3 {
        margin: 0;
        color: #484848;
        font-size: 14px;
        font-weight: 400;
        text-transform: capitalize;
      }
    }
  }

  ${mediaQuery.desktop`
  .header {
    padding: 15px;
    color: #333333;
    font-weight: 700;
    text-transform: capitalize;
    font-size: 18px;
    border-bottom: 1px solid #e0e0e0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h4 {
      margin: 0;
      color: #549a9a;
      font-size: 14px;
      font-weight: 700;
      cursor: pointer;
    }
  }
  
  `}

  .body {
    padding: 15px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    h4 {
      color: #333333;
      font-weight: 700;
      font-size: 14px;
      margin: 0;
    }

    label {
      color: #4f4f4f;
      font-weight: 400;
      font-size: 14px;
    }

    input {
      border-radius: 5px;
      padding: 5px;
      border: 1px solid #e0e0e0;
      font-size: 16px;

      &:focus {
        outline: none;
        border: 2px solid #549a9a;
      }
    }

    .pickup {
      display: flex;
      flex-direction: column;
      gap: 2px;
    }

    .days {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      align-items: center;
      width: 250px;
    }

    h5 {
      color: #4f4f4f;
      font-weight: 400;
      font-size: 14px;
      margin: 0;
      margin-top: 1px;
      white-space: no-wrap;
    }

    h6 {
      margin: 0;
      text-align: center;
      margin-top: 24px;
      font-size: 16px;
    }
  }
`;

export const FormBody = styled.div`
  ${
    '' /* display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  box-sizing: border-box;
  padding: 26px 22px;
  gap: 10px;
  background: #ffffff;
  border: 1px solid #e1e1e1;
  border-radius: 4px; */
  }

  .box {
    display: flex;
    flex-direction: column;
    padding: 0px;
    width: 100%;
    box-sizing: border-box;
    height: auto;
  }

  .form_container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    ${'' /* padding-bottom: 10px; */}
    width: 100%;
    box-sizing: border-box;

    > input {
      width: 100%;
      box-sizing: border-box;
      height: 50px;
      background: #ffffff;
      border: 1px solid #e1e1e1;
      border-radius: 4px;
    }
  }

  .select_form_container {
    display: flex;
    flex-direction: column;
    max-width: 100%;
    width: 100%;
    box-sizing: border-box;
  }

  .first__select {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    gap: 8px;
    margin-top: 10px;

    > select {
      padding: 17px 12px;
      width: 100%;
      box-sizing: border-box;
      height: 50px;
      background: #ffffff;
      border: 1px solid #e1e1e1;
      border-radius: 4px;
    }

    > input {
      width: 100%;
      box-sizing: border-box;
      height: 50px;
      background: #ffffff;
      border: 1px solid #e1e1e1;
      border-radius: 4px;
    }
  }

  .heading__container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0px;
    gap: 853px;
    width: 891px;
    height: 36px;
  }

  .heading {
    width: 149px;
    height: 27px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 26px;
    color: #333333;
  }

  .input_heading {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    height: 23px;
  }

  .form__button {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    align-content: center;
    background-color: #549a9a;
    width: 100%;
    box-sizing: border-box;
    margin-top: 35px;
    text-align: center;
    border-radius: 5px;
    height: 50px;
    justify-content: center;
    cursor: pointer;
    padding: 1rem 2rem;
    color: #fff;
    font-weight: 400;
    border: none;
  }

  ${mediaQuery.desktop`
display: block;
width: 100%;
box-sizing: border-box;
flex-direction: column;
padding: 26px 22px;
gap: 10px;
background: #FFFFFF;
border-radius: 4px;


  .box {
    display: flex;
    flex-direction: column;
    padding: 0px;
    gap: 0;
    width: 100%;
    box-szing: border-box;
  }

  .form_container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-bottom: 10px;
    width: 100%;
    box-sizing: border-box;

    > input {
      width: 100%;
      height: 50px;
      background: #ffffff;
      border: 1px solid #e1e1e1;
      border-radius: 4px;
      box-sizing: border-box;
    }
  }

  .select_form_container {
   display: flex;
   flex-direction: row;
   gap: 20px;
   width: 100%;
   max-width: 100%;
  box-sizing: border-box;
  margin-top: 10px;
  }

  .first__select {
    display: flex;
    flex-direction: column;
    padding: 0px;
    gap: 8px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;

    > select {
      padding: 17px 12px;
      width: 100%;
      height: 50px;
      background: #ffffff;
      border: 1px solid #e1e1e1;
      border-radius: 4px;
      box-sizing: border-box;
    }

    > input {
      width: 100%;
      box-sizing: border-box;
      height: 50px;
      background: #ffffff;
      border: 1px solid #e1e1e1;
      border-radius: 4px;
    }
  }

  .heading__container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0px;
    gap: 853px;
    width: 891px;
    height: 36px;
  }

  .heading {
    width: 149px;
    height: 27px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 26px;
    color: #333333;
  }

  .input_heading {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    height: 23px;
  }

  .form__button {
    display: flex;
    flex-wrap: wrap;
  align-items: center;
  align-content: center;
  background-color: #549A9A;
  width: 100%;
  text-align: center;
  border-radius: 5px;
  height: 50px;
  justify-content:center;
  cursor: pointer;
  borer: 1px solid red;
  box-sizing: border-box;
  padding: 1rem 2rem;
  color: #fff;
  font-weight: 400;
  }


  `}
`;

export const DeleteModal = styled.div`
  width: 320px;
  height: 196px;

  .delete__header {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0px;
    isolation: isolate;
  }

  .header_text-1 {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 25px;
    text-align: center;
    color: #333333;
  }

  .header_text-2 {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 15px;
    text-align: center;
    color: #4f4f4f;
  }

  .action__button {
    display: flex;
    justify-content: center;
    width: 320px;
    height: 30px;
    gap: 10px;
  }

  ${mediaQuery.desktop`
  width: 400px;
  height: 196px;
  background: #ffffff;

  .delete__header {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0px;
    isolation: isolate;
    width: 550px;
    height: 96px;
  }

  .header_text-1 {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 25px;
    text-align: center;
    color: #333333;
  }

  .header_text-2 {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: #4f4f4f;
  }

  .action__button {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding: 32px 0px 0px;
    width: 550px;
    height: 99px;
    gap: 10px;
  }
  `}
`;

export const AddressContainer = styled.div`
  background: #fff;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  width: auto;

  .header {
    padding: 15px;
    color: #333333;
    font-weight: 700;
    text-transform: capitalize;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    border-bottom: 1px solid #e0e0e0;

    h4 {
      margin: 0;
      color: #549a9a;
      font-size: 12px;
      font-weight: 700;
      cursor: pointer;
      white-space: nowrap;
    }
  }

  ${mediaQuery.desktop`
  .header {
    padding: 15px;
    color: #333333;
    font-weight: 700;
    text-transform: capitalize;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 18px;
    border-bottom: 1px solid #e0e0e0;

    h4 {
      margin: 0;
      color: #549a9a;
      font-size: 14px;
      font-weight: 700;
      cursor: pointer;
    }
  }
  `}

  .body {
    padding: 15px;
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 15px;
  }

  ${mediaQuery.desktop`
  .body {
    padding: 15px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }
  `}

  .locations {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 15px;
  }

  ${mediaQuery.desktop`
  .locations {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 5px;
  }
  `}

  .delivery_region {
    padding: 15px;

    p {
      margin: 0;
      margin-bottom: 10px;
      font-size: 16px;
      font-weight: 700;
    }
  }

  .locations_card {
    padding: 14px;
    cursor: pointer;
    border-radius: 5px;
    width: auto;
    border: 1px solid #e0e0e0;

    p {
      margin: 0;
      color: #0b0b0b;
      margin-bottom: 6px;
      font-size: 16px;
      font-weight: 500;
    }

    h3 {
      margin: 0;
      color: #484848;
      font-size: 14px;
      font-weight: 400;
      text-transform: capitalize;
    }
  }

  .card {
    border: 1px solid #549a9a;
    border-radius: 4px;
    cursor: pointer;

    .card_content {
      padding: 14px;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;

      h3 {
        margin: 0;
        color: #0b0b0b;
        margin-bottom: 6px;
        font-size: 16px;
        font-weight: 500;
      }

      h4 {
        color: #484848;
        margin: 0;
        font-size: 14px;
        font-weight: 400;
        text-transform: capitalize;
      }

      h5 {
        margin: 0;
        color: #484848;
        font-size: 14px;
        font-weight: 400;
        margin-top: 4px;
      }

      h6 {
        margin: 0;
        color: #484848;
        font-size: 14px;
        font-weight: 500;
        margin-top: 4px;
      }

      .select {
        border: 1px solid #549a9a;
        background: #d4e7e7;
        width: 16px;
        height: 16px;
        border-radius: 100%;
        display: grid;
        place-items: center;

        .inner {
          background: #549a9a;
          width: 6px;
          height: 6px;
          border-radius: 100%;
        }
      }
    }

    .footer {
      padding: 15px 10px;
      border-top: 1px solid #e0e0e0;
      display: flex;
      justify-content: flex-end;

      .footer_content {
        display: flex;
        gap: 10px;
        align-items: center;

        h4 {
          color: #549a9a;
          font-size: 14px;
          font-weight: 400;
          margin: 0;
          cursor: pointer;
        }

        .delete {
          color: #d92d20;
        }
      }
    }
  }

  .pricing {
    display: flex;
    flex-direction: column;
    gap: 13px;
  }

  .price_list {
    display: flex;
    gap: 8px;
  }

  .title {
    color: #333333;
    font-size: 14px;
    font-weight: 700;
  }

  .amount {
    font-size: 12px;
    color: #4f4f4f;
    font-weight: 400;
  }
`;

export const Toast = styled.div`
  width: auto;
  display: ${({ show }) => (show ? 'inline-block' : 'none')};
  z-index: 3;
  position: fixed;
  top: ${({ show }) => (show ? '14%' : '-100%')};
  left: 0;
  right: 0;
  transition: all 0.3s ease-in-out;
  opacity: ${({ show }) => (show ? '100%' : '0')};

  .content {
    padding: 16px;
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: space-between;
    margin-left: 11px;
    margin-right: 11px;
    font-size: 16px;
    color: #d92d20;
    font-weight: 600;
    background: #ffd6d6;
    border-radius: 8px;
    border: 1px solid #d92d20;
    box-shadow: 0px 4px 6px -2px #10182808;
    box-shadow: 0px 12px 16px -4px #10182814;
  }

  ${mediaQuery.desktop`
  width: auto;
  display: ${({ show }) => (show ? 'inline-block' : 'none')};
  z-index: 3;
  position: fixed;
  top: ${({ show }) => (show ? '0' : '-100%')};
  margin-top: 80px;
  left: 0;
  right: 0;
  transition: display 0.3s ease-in-out;
  opacity: ${({ show }) => (show ? '100%' : '0')};


  .content {
    width: 850px;
    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-left: 64px;
    margin-right: 24px;
    font-size: 16px;
    color: #d92d20;
    font-weight: 600;
    background: #ffd6d6;
    border-radius: 8px;
    border: 1px solid #d92d20;
    box-shadow: 0px 4px 6px -2px #10182808;
    box-shadow: 0px 12px 16px -4px #10182814;
  }
  
  `}
`;

export const DateSelect = styled.div`
  margin-top: 23px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  h3 {
    color: #000;
    font-size: 15px;
    font-weight: 600;
    margin: 0;
    padding: 0;
    color: #549a9a;
  }

  label {
    color: #333333;
    font-size: 16px;
    font-weight: 700;
  }

  > input {
    background: #fff;
    border: 1px solid #e1e1e1;
    border-radius: 4px;
    padding: 12px 16px;
  }
`;
